import React from 'react';

const Jira = (props) => (
  <svg
    fill="currentColor"
    stroke="currentColor"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7 7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H7zm14.7 6.3l-8 8a1 1 0 0 1-1.4 0l-4-4 1.4-1.4L13 19.2l7.3-7.3 1.4 1.4z" />
  </svg>
);

export default Jira;
